import { createSelector } from 'reselect'
import skinSelector from '../app/skinSelector'
import { IStore } from '../../reducers/index'

const previewSelector = (state: IStore) => state.preview

const sizeSelector = (state: IStore) => state.app.size

export default createSelector(previewSelector, skinSelector, sizeSelector, (preview, skinData, size) => {
	const skin = {
		...skinData.game.questions,
		particleSystems: null,
	}
	const activities = preview.activities.map((activity: any) => {
		return {
			...activity,
			assetSource: activity.asset ? activity.asset.source : '',
		}
	})
	return {
		activities,
		skin,
		size,
	}
})
